import axiosClient from "@/utils/axios-client";
import {
  MyDashboardLineSheetByBrandData,
  MyDashboardLineSheetByBrandParams,
  MyDashboardLinkedUrlSiteInfoData,
  MyDashboardLinkUrlSiteParams,
  MyDashboardProductByCategoryData,
  MyDashboardProductByCategoryParams,
} from "@/features/my-dashboard/types";

const url = {
  getProductsByCategory: () => "/dashboards/my/products-by-category",
  getLineSheetByBrand: () => "/dashboards/my/line_sheet_set_by_brand",
  getLinkedUrlSiteInfo: (buyer_id?: number) =>
    `/buyers/${buyer_id}/sync-shopping-mall`,

  postLinkUrlSite: (buyer_id?: number) =>
    `/buyers/${buyer_id}/requests/sync-shopping-mall`,
  uploadUnoFile: () => `/uno-files`,
};

export const myDashboardApi = {
  getProductsByCategory: async (params: MyDashboardProductByCategoryParams) => {
    const { data } = await axiosClient.get<MyDashboardProductByCategoryData[]>(
      url.getProductsByCategory(),
      {
        params,
      }
    );
    return data;
  },

  getLineSheetByBrand: async (params: MyDashboardLineSheetByBrandParams) => {
    const { data } = await axiosClient.get<MyDashboardLineSheetByBrandData[]>(
      url.getLineSheetByBrand(),
      {
        params,
      }
    );
    return data;
  },

  getLinkedUrlSiteInfo: async (buyer_id?: number) => {
    const { data } =
      await axiosClient.get<MyDashboardLinkedUrlSiteInfoData | null>(
        url.getLinkedUrlSiteInfo(buyer_id)
      );
    return data;
  },

  postLinkUrlSite: async (
    params: MyDashboardLinkUrlSiteParams,
    buyer_id?: number
  ) => await axiosClient.post(url.postLinkUrlSite(buyer_id), params),

  uploadUnoFile: async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    // 파일 업로드는 인스턴스 기본값 30초로 끊으면 안 된다.
    return await axiosClient.post(url.uploadUnoFile(), formData, {
      timeout: 60 * 60 * 1000,
    });
  },
};
